import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Header.css';
import searchIcon from '../../assets/header/searchIcon.png';
import notificationIcon from '../../assets/header/notificationIcon.png';
import backIcon from '../../assets/backIcon.png';
import profileDefault from '../../assets/profileDefault.png';
//redux
import { useSelector, useDispatch } from 'react-redux';
import { setSearchTerm } from '../../store/slices/searchSlice';
// WebSocket hook para notificaciones
import useWebSocket from '../../hooks/useWebSocket';

const Header = () => {
  const customerName = useSelector((state) => state.customer.customerName);
  const URLProfile = process.env.REACT_APP_PROFILE_URL;
  const [profilePhoto, setProfilePhoto] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const { userData } = useSelector((state) => state.user);
  const { searchTerm } = useSelector((state) => state.search);
  const dispatch = useDispatch();
  
  // Usar el hook de WebSocket para obtener el contador de notificaciones no leídas
  const { unreadCount, markAllAsRead } = useWebSocket();
  const handleProfileClick = () => {
    navigate('/profile');
  };

  const showBackButton = location.pathname !== '/dashboard';

  const shouldReturnToDashboard = () => {
    const dashboardRoutes = [
      '/users',
      '/support',
      '/dashboard/help',
      '/groups',
      '/customers',
      '/dashboard/roles',
      '/dashboard/tokens',
      '/dashboard/dashboard',
      '/configurations',
    ];
    return dashboardRoutes.includes(location.pathname);
  };

  const handleBack = () => {
    if (shouldReturnToDashboard()) {
      navigate('/dashboard');
    } else {
      navigate(-1);
    }
  };

  const getViewName = () => {
    let path = location.pathname;
    const id = path.split('/').pop();
    if(!Number.isNaN(Number(id))) {
      path = path.replace(id, '');
    }
    const viewMap = {
      //User management
      '/users': 'User management',
      '/users/new-user': 'New user',
      '/users/edit-user/': 'Edit user',
      //Support
      '/support': 'Support',
      '/support/details/': 'Support details',
      '/support/assign/': 'Support assign',
      '/support/check/': 'Support status change',
      '/support/suggested-price': 'Suggested price',
      //Group management
      '/groups': 'Group management',
      '/groups/new-group': 'New group',
      '/groups/edit-group/': 'Edit group',
      '/groups/group-details/': 'Group details',
      //Customer management
      '/customers': 'Customer management',
      '/customers/info-customer/': customerName || 'User name',
      '/customers/request-history/': customerName || 'User name',
      '/customers/service-history/': customerName || 'User name',
      '/customers/support/': customerName || 'User name',
      '/customers/support/check/': customerName || 'User name',
      '/customers/groups/': customerName || 'User name',
      //Roles
      '/dashboard/roles': 'Roles',
      '/dashboard/role/new-role': 'New role',
      '/dashboard/role/edit-role/': 'Edit role',
      //Barter Bucks
      '/dashboard/tokens': 'Barter bucks',
      '/dashboard/tokens/new-token': 'New token',
      '/dashboard/tokens/edit-token/': 'Package name',
      '/dashboard/tokens/support-token': 'Support token',
      //Dashboard
      '/dashboard/dashboard': 'Dashboard',
      //Profile
      '/profile': 'Profile',
      '/profile/change-password': 'Change Password',
      //Notifications
      '/notifications': 'Notifications',
      //Configurations
      '/configurations': 'Configurations',
      '/configurations/suggested-price/new': 'Add suggested price',
      '/configurations/suggested-price/edit/': 'Edit suggested price',
    };
    return viewMap[path] || 'Dashboard';
  };

  useEffect(() => {
    if (userData?.profile?.profile_photo) {
      setProfilePhoto(URLProfile + userData?.profile?.profile_photo);
    }
  }, [userData]);

  return (
    <header className="header">
      {showBackButton && (
        <button 
          className="header-left" 
          onClick={handleBack}
          type="button"
        >
          <img src={backIcon} alt="Back" className="back-icon" />
          <span className="back-text">{getViewName()}</span>
        </button>
        )}
        <div className="search-container">
          <div className="search-input-container">
            <img src={searchIcon} alt="Search" />
            <input 
              type="text" 
              placeholder="Search..." 
              className="search-input"
            icon={searchIcon}
              value={searchTerm}
              onChange={(e) => dispatch(setSearchTerm(e.target.value))}
            />
          </div>
          <button 
            className="notification-btn" 
            onClick={() => {
              navigate('/notifications');
              // Marcar notificaciones como leídas al navegar a la página de notificaciones
              markAllAsRead();
            }}
          >
            <span className="notification-icon">
              <img src={notificationIcon} alt="Notification" className="notificationIcon" />
              {unreadCount > 0 && (
                <span className="notification-badge">{unreadCount > 99 ? '99+' : unreadCount}</span>
              )}
            </span>
          </button>
          <div 
            className="user-profile" 
            onClick={handleProfileClick}
            role="button"
            tabIndex={0}
          >
            <img 
              src={profilePhoto || profileDefault}
              alt="User" 
              className="profile-image"
            />
        </div>
      </div>
    </header>
  );
};

export default Header;
